import { graphClient } from '../graph-client'
import {
  GET_ROCKET_GAME,
  GET_ROCKET_GAME_FIRST,
  GET_ROCKETS_GAMES,
  GET_ROCKETS_GAMES_SUM,
  GET_ROCKETS_GAMES_SUM_ALL,
} from './gql'

import type {
  Get,
  GetFirst,
  GetList,
  GetSum,
  GetSumAll,
} from './types'

class RocketGameService {
  async get(params: Get.Input) {
    const request = await graphClient.request<Get.Output>(
      GET_ROCKET_GAME,
      params,
    )

    return request?.getRocketGame
  }

  async getFirst(params: GetFirst.Input) {
    const request = await graphClient.request<GetFirst.Output>(
      GET_ROCKET_GAME_FIRST,
      params,
    )

    return request?.getRocketGameFirst
  }

  async getSum(params: GetSum.Input) {
    const request = await graphClient.request<GetSum.Output>(
      GET_ROCKETS_GAMES_SUM,
      params,
    )

    return request?.getRocketsGamesSum
  }

  async getSumAll(params: GetSumAll.Input) {
    const request = await graphClient.request<GetSumAll.Output>(
      GET_ROCKETS_GAMES_SUM_ALL,
      params,
    )

    return request?.getRocketsGamesSumAll
  }

  async getList(params: GetList.Input) {
    const request = await graphClient.request<GetList.Output>(
      GET_ROCKETS_GAMES,
      {
        ...params,
        skip: (params.take ?? 20) * (params.skip ?? 0),
      },
    )

    return request?.getRocketsGames
  }
}
export const rocketGameService = new RocketGameService()
